import React, { Component } from 'react';
import aidao from './../../../assets/images/Aidao.svg';
import ether from './../../../assets/images/Ethereum.svg';
import cobinhood from './../../../assets/images/cobinhood.svg';
import wandx from './../../../assets/images/wandx.svg';
import golem from './../../../assets/images/Golem.svg';
import fuzex from './../../../assets/images/fuzex.svg';
import ncash from './../../../assets/images/ncash.svg';
import xyo from './../../../assets/images/xyo.svg';
import bitrewards from './../../../assets/images/bit.svg';
import credits from './../../../assets/images/credit.svg';
import cybermiles from './../../../assets/images/cybermiles.svg';
import essentia from './../../../assets/images/ess.svg';
import singularity from "./../../../assets/images/singularity.svg";
import autonio from "./../../../assets/images/auto.svg";
import stacs from "./../../../assets/images/stacs-logo.svg";
import orbs from "./../../../assets/images/orbs-logo.svg";
import incodium from "./../../../assets/images/inco.svg";
import mon from "./../../../assets/images/mon.svg";
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';
import Pending from './pending.js';
import PopUp from './popup.js';
import fee from './../../data/fee'

export default class SendTransaction extends Component {

  render() {

    const data = this.props.data;

    var kyc = window.kyc;
    var page = this.props.name;
    var withdraw = this.props.withdraw;
    var otp = window.otp;

    axios.defaults.xsrfCookieName = 'csrftoken'
    axios.defaults.xsrfHeaderName = 'X-CSRFToken'

    if (otp === "False") {
      $( document ).ready(function() {
          $("#otp-block").css("display", "none");
      });
    }

    if (withdraw === "True") {
      $( document ).ready(function() {
        $(".title-send").html(data.withdraw);
        $("#sendbutton").html(data.withdraw);
        $(".withdraw-warning").css("display", "block");
        $("#gas-price-block").css("display", "none");
      });
    }

    if (page === "aidao") {
      $( document ).ready(function() {
        $(".token-deduction-warning").css("display", "block");
      });
    }

    var rate;
    if (page === "cobinhood") {
      rate = (window.cobinhoodprice / window.daoprice).toFixed(2);
    } else if (page === "cybermiles") {
      rate = (window.cybermilesprice / window.daoprice).toFixed(2);
    } else if (page === "wandx") {
      rate = (window.wandxprice / window.daoprice).toFixed(2);
    } else if (page === "fuzex") {
      rate = (window.fuzexprice / window.daoprice).toFixed(2);
    } else if (page === "xyo") {
      rate = (window.xyoprice / window.daoprice).toFixed(2);
    } else if (page === "ncash") {
      rate = (window.ncashprice / window.daoprice).toFixed(2);
    } else if (page === "bitrewards") {
      rate = (window.bitrewardsprice / window.daoprice).toFixed(2);
    } else if (page === "essentia") {
      rate = (window.essentiaprice / window.daoprice).toFixed(2);
    } else if (page === "singularitynet") {
      rate = (window.agiprice / window.daoprice).toFixed(2);
    } else if (page === "credits") {
      rate = (window.creditsprice / window.daoprice).toFixed(2);
    } else if (page === "autonio") {
      rate = (window.autonioprice / window.daoprice).toFixed(2);
    } else if (page === "stacs") {
      rate = (window.stacsprice / window.daoprice).toFixed(2);
    } else if (page === "orbs") {
      rate = (window.orbsprice / window.daoprice).toFixed(2);
    } else if (page === "incodium") {
      rate = (window.incodiumprice / window.daoprice).toFixed(2);
    } else if (page === "moneynet") {
      rate = (window.moneynetprice / window.daoprice).toFixed(2);
    }



    var send = function(){
      var value = parseFloat($('#amount-sending').val());

      var words;
      if (withdraw === "True") {
        var deduct = value * rate;
        words = " " + deduct.toString() + " " + data.deductDao + '\n';
        words += data.fee + fee[page].toString() + ' ' + page;
      } else if (page === "aidao") {
        words = data.deductToken;
      } else {
        words = "";
      }

      if (confirm(data.sendToken + words) === true) {

        if (value < fee[page]) {
          alert("Failed. The fee is greater than your withdraw amount.");
          return;
        }

        var sendTo = $('#receiver').val();
        var otp = $('#otp-sending').val();
        var type = page;
        var promise;

        if (withdraw === "True") {
          $("#sendbutton").html(data.submitting);
          $('#sendbutton').prop('disabled', true);

          console.log("withdrawing");
          promise = axios.post('/api/withdraw',qs.stringify(
            {
              "sendTo": sendTo,
              "value": value,
              "type": type,
              "otp": otp,
            })
          );

          promise.then(function (response) {
            $("#sendbutton").html(data.withdraw);
            $('#sendbutton').prop('disabled', false);
            console.log(response.data.status);
            if (response.data.status === false){
              console.log(response.data.message);
              PopUp.prototype.show(response.data.message);
            } else {
              console.log(response.data.message);
              PopUp.prototype.show(data.success + "!\n" + response.data.message);
            }
          });

          promise.catch(function (error) {
            PopUp.prototype.show(data.failed + ":\n" + error.response.data.message);
            $("#sendbutton").html(data.withdraw);
            $('#sendbutton').prop('disabled', false);
          });

        } else {
          $("#sendbutton").html(data.sending);
          $('#sendbutton').prop('disabled', true);

          var gasprice = $('#gas-price').val();

          promise = axios.post('/api/sendtransaction',qs.stringify(
            {
              "sendTo": sendTo,
              "value": value,
              "type": type,
              "otp": otp,
              "gasprice": gasprice,
            })
          );

          promise.then(function (response) {
            var result = response.data;
            console.log(result)

            $("#sendbutton").html(data.send);
            $('#sendbutton').prop('disabled', false);
            PopUp.prototype.show(data.sentSuccessfully + ":\n" +
              result.INFO);
            $('#receiver').val("");
            $('#amount-sending').val("");
            window.etherbalance = result.balance.ether;
            window.daobalance = result.balance.aidao;

            // THIS IS OLD
            window.golembalance = result.balance.golem;
            window.cobinhoodbalance = result.balance.cobinhood;
            $("#etherbalance").html(window.etherbalance);
            $("#daobalance").html(window.daobalance);
            $("#golembalance").html(window.golembalance);
            $("#cobinhoodbalance").html(window.cobinhoodbalance);
            // UNTIL HERE NEED TO Change

          });

          promise.catch(function (error) {
            PopUp.prototype.show(data.failed + "\n" + error.response.data.message + "\n" + data.checkPending);
            $("#sendbutton").html(data.send);
            $('#sendbutton').prop('disabled', false);
            Pending.prototype.getpending();
          });
        }
      }
    }

    var title, image;
    if (page === 'aidao'){
      // Master User only
      title = data.daoToken;
      image = aidao;
    } else if (page === 'ether') {
      title = "Ether";
      image = ether;
    } else if (page === 'golem') {
      title = "Golem";
      image = golem;
    } else if (page === 'cobinhood') {
      title = "Cobinhood";
      image = cobinhood;
    } else if (page === 'cybermiles') {
      title = "CyberMiles";
      image = cybermiles;
    } else if (page === 'wandx') {
      title = "Wandx";
      image = wandx;
    } else if (page === 'fuzex') {
      title = "FXT";
      image = fuzex;
    } else if (page === 'xyo') {
      title = "XYO";
      image = xyo;
    } else if (page === 'ncash') {
      title = "NCash";
      image = ncash;
    } else if (page === 'bitrewards') {
      title = "BitRewards";
      image = bitrewards;
    } else if (page === 'essentia') {
      title = "Essentia";
      image = essentia;
    } else if (page === 'singularitynet') {
      title = "Singularity Net";
      image = singularity;
    } else if (page === 'credits') {
      title = "Credits";
      image = credits;
    } else if (page === 'autonio') {
      title = "Autonio";
      image = autonio;
    } else if (page === 'stacs') {
      title = "Stacs";
      image = stacs;
    } else if (page === 'orbs') {
      title = "Orbs";
      image = orbs;
    } else if (page === 'incodium') {
      title = "Incodium";
      image = incodium;
    } else if (page === 'moneynet') {
      title = "MoneyNet";
      image = mon;
    }




    if ((withdraw === "True" && kyc > 2) || (withdraw === undefined && kyc > 1)) {
      return (
        <div id="con-close-modal" class="modal fade in" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                  <div class="modal-dialog">
                      <div class="modal-content">
                          <div class="modal-header">
                              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                              <h4 class="modal-title text-left"><img src={ image } class="token32" alt="token icon"/>  <span class="title-send">{data.send}</span> { title } {data.to}</h4>
                          </div>

                          <div class="modal-body">

                              <div class="row withdraw-warning">
                                <div class="col-md-12">
                                  <div class="panel panel-color panel-warning">
                                    <div class="panel-heading">
                                        <h3 class="panel-title"> {data.notice}</h3>
                                    </div>
                                    <div class="panel-body">
                                        <p>
                                            {data.withdrawDeductsDao}
                                        </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row token-deduction-warning">
                                <div class="col-md-12">
                                  <div class="panel panel-color panel-warning">
                                    <div class="panel-heading">
                                        <h3 class="panel-title"> {data.notice}</h3>
                                    </div>
                                    <div class="panel-body">
                                        <p>
                                            {data.aidaosendingwarning}
                                        </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="form-group">
                                          <label for="field-3" class="control-label pull-left">To :</label>
                                          <input type="text" class="form-control" id="receiver" placeholder={data.address}/>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="form-group">
                                          <label for="field-3" class="control-label pull-left">Amount :</label>
                                          <input type="text" class="form-control" id="amount-sending" placeholder={data.amount} />
                                      </div>
                                  </div>
                              </div>

                              <div class="row" id="gas-price-block">
                                  <div class="col-md-12">
                                      <div class="form-group">
                                          <label for="field-3" class="control-label pull-left">Gas Price :</label>
                                          <input type="text" class="form-control" id="gas-price" placeholder={data.gwei}/>
                                      </div>
                                  </div>
                              </div>

                              <div class="row" id="otp-block">
                                  <div class="col-md-12">
                                      <div class="form-group">
                                          <label for="field-3" class="control-label pull-left">OTP</label>
                                          <input type="text" class="form-control" id="otp-sending" placeholder={data.otpcode} />
                                      </div>
                                  </div>
                              </div>

                          </div>
                          <div class="modal-footer">
                              <button type="button" class="btn btn-default waves-effect" data-dismiss="modal">{data.close}</button>
                              <button type="button" id="sendbutton" onClick={send} class="btn btn-info waves-effect waves-light">{data.send}</button>
                          </div>
                      </div>
                  </div>
        </div>
        );
    } else {
      return (
        <div id="con-close-modal" class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title">{data.kycRequired}</h4>
                    </div>
                <div class="modal-body">
                    <p class='textalign'>{data.kycRequiredforTransaction}</p>
                    <p class='textalign'>{data.daoWalletTeam}</p>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal">{data.close}</button>
                </div>
              </div>
          </div>
        </div>
      );
    }



  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/send_transaction.js